<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Action Trigger Type-->
<div class="at-SubMenu">
	<!--Heading-->
	<h4>Select Action Trigger Type</h4>

	<!--Option Grid-->
	<div class="at-OptionGrid">
		<label>Action Trigger Type:</label>

		<select class="form-control" name="CausedByID" (ngModelChange)="onCausedByChange($event)" [(ngModel)]="CausedByID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstCausedBy" [ngValue]="o.ActionTriggerTypeID">
				{{ o.ActionTriggerTypeDesc }}
			</option>
		</select>
	</div>
</div>

<!--Caused By Options------------------------------------------------------------------------------>
<div class="at-SubMenu" *ngIf="ShowCausedByMenu()">
	<!--Heading-->
	<h4>Action Trigger Caused By: {{ CausedByText }}</h4>

	<!--Option Grid-->
	<div class="at-OptionGrid">
		<!--Daily Attendance-->
		<label *ngIf="ShowDailyAttendance()">Daily Attendance Status:</label>
		<select *ngIf="ShowDailyAttendance()" class="form-control" [(ngModel)]="SelectedAttendanceStatusID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAttendanceStatus" [ngValue]="o.AttendanceStatusID">
				{{ o.AttendanceStatusDesc }}
			</option>
		</select>

		<!--Class Attendance-->
		<label *ngIf="ShowClassAttendance()">Class Attendance Status:</label>
		<select *ngIf="ShowClassAttendance()" class="form-control" [(ngModel)]="SelectedAttendanceStatusID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstClassAttendanceStatus" [ngValue]="o.ClassAttendanceStatusID">
				{{ o.ClassAttendanceStatusDesc }}
			</option>
		</select>

		<!--Infraction-->
		<label *ngIf="ShowInfraction()">Infraction Type:</label>
		<select *ngIf="ShowInfraction()" class="form-control" [(ngModel)]="SelectedInfractionID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstInfraction" [ngValue]="o.InfractionID">
				{{ o.InfractionDesc }}
			</option>
		</select>

		<!--Penalty-->
		<label *ngIf="ShowPenalty()">Penalty Type:</label>
		<select *ngIf="ShowPenalty()" class="form-control" [(ngModel)]="SelectedPenaltyID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstPenalty" [ngValue]="o.PenaltyID">
				{{ o.PenaltyDesc }}
			</option>
		</select>

		<!--Merit/Demerit-->
		<label *ngIf="ShowMeritDemerit()">Merit/Demerit Type:</label>
		<select *ngIf="ShowMeritDemerit()" class="form-control" [(ngModel)]="SelectedMeritID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstMerits" [ngValue]="o.MeritID">
				{{ o.MeritDesc }}
			</option>
		</select>

		<label *ngIf="ShowActionValue()">Action Value</label>
		<input min="0" class="form-control" *ngIf="ShowActionValue()" type="number" [(ngModel)]="ActionValue" />

		<label for="ConsecutiveInd" *ngIf="ShowActionCountConsec()">Action Counts must be Consecutive</label>
		<input id="ConsecutiveInd" class="form-control" *ngIf="ShowActionCountConsec()" type="checkbox" [(ngModel)]="ConsecutiveInd" />
	</div>
</div>

<!------------------------------------------------------------------------------------------------->

<!--Result Type-->
<div class="at-SubMenu">
	<!--Heading-->
	<h4>Select Action Result Type</h4>

	<!--Option Grid-->
	<div class="at-OptionGrid">
		<label>Action Trigger Result Type:</label>
		<select class="form-control" name="ResultTypeID" (ngModelChange)="onResultTypeChange($event)" [(ngModel)]="ResultTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActionResultType" [ngValue]="o.ActionTriggerActionTypeID">
				{{ o.ActionTriggerActionTypeDesc }}
			</option>
		</select>
	</div>
</div>

<!--Results In-->
<div class="at-SubMenu">
	<!--Heading-->
	<h4>Action Trigger Results In: {{ ResultsTypeText }}</h4>

	<!--Option Grid-->
	<div class="at-OptionGrid">
		<!--Incident-->
		<label *ngIf="ResultTypeID == 3">Infraction Type:</label>
		<select *ngIf="ResultTypeID == 3" class="form-control" (ngModelChange)="onSecondInfractionChange($event)" [(ngModel)]="SecondSelectedInfractionID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSecondInfraction" [ngValue]="o.InfractionID">
				{{ o.InfractionDesc }}
			</option>
		</select>

		<label *ngIf="ResultTypeID == 3">Penalty Type:</label>
		<select *ngIf="ResultTypeID == 3" class="form-control" [(ngModel)]="SecondSelectedPenaltyID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSecondPenalty" [ngValue]="o.PenaltyID">
				{{ o.PenaltyDesc }}
			</option>
		</select>

		<!--Merit/Demerit-->
		<label *ngIf="ResultTypeID == 4">Merit/Demerit Type:</label>
		<select *ngIf="ResultTypeID == 4" class="form-control" (ngModelChange)="onSecondSelectedMeritChange($event)" [(ngModel)]="SecondSelectedMeritID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSecondMerits" [ngValue]="o.MeritID">
				{{ o.MeritDesc }}
			</option>
		</select>

		<label *ngIf="ResultTypeID == 4">Merit/Demerit Value:</label>
		<label *ngIf="ResultTypeID == 4">{{ MeritValue }}</label>
	</div>
</div>

<!--General-->
<div class="at-SubMenu">
	<h4>General:</h4>

	<!--Option Grid-->
	<div class="at-OptionGrid">
		<label for="RecurrentInd">Triggered Action is Recurrent:</label>
		<input id="RecurrentInd" class="form-control" type="checkbox" [(ngModel)]="RecurrentInd" />

		<label>Action Trigger Reset Type:</label>
		<select class="form-control" [(ngModel)]="SelectedATRID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActionTriggerReset" [ngValue]="o.ActionTriggerResetTypeID">
				{{ o.ActionTriggerResetTypeDesc }}
			</option>
		</select>

		<label>Administrator</label>
		<select class="form-control" [(ngModel)]="SelectedAdminID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAdmin" [ngValue]="o.AdministratorID">
				{{ o.Administrator }}
			</option>
		</select>
	</div>
</div>

<!--Buttons-->
<div class="at-Buttons TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add Trigger</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
